import { useState, useRef, useEffect } from 'react'
//import { useFetch } from '../../hooks/useFetch'
//import { useHistory } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { projectFirestore, timestamp } from '../../firebase/config'
import { useAuthContext } from "../../hooks/useAuthContext"

// styles
import './Create.css'

export default function Create() {
  const [title, setTitle] = useState('')
  const [body, setBody] = useState('')
  // const [cookingTime, setCookingTime] = useState('')
  const [newIngredient, setNewIngredient] = useState('')
  //const [ingredients, setIngredients] = useState([])
  const [tags, setTags] = useState([])
  const ingredientInput = useRef(null)

  const [author, setAuthor] = useState('')
  const [complete, setComplete] = useState(false)
  //const [createdAt, setCreatedAt] = useState('')
  const [reviews, setReviews] = useState(1)
  const [stars, setStars] = useState(3)
  const [uid, setUid] = useState('')
  let [max, setMax] = useState(0)

  //const { postData, data } = useFetch('http://localhost:3000/recipes', 'POST')
  const navigate = useNavigate()
  const { user } = useAuthContext()

  const handleSubmit = async (e) => {
    e.preventDefault()
    const createdAt = timestamp.fromDate(new Date)
    const doc = {
      title, tags, body,
      author: user.displayName, complete, createdAt, 
      reviews, stars, uid: user.uid
    }

    try {
      await projectFirestore.collection('recipes').add(doc)
      navigate('/')  //history.push('/')
    } catch (err) {
      console.log(err)
    }
  }

  const handleAdd = (e) => {
    e.preventDefault()
    const ing = newIngredient.trim()

    if (max < 3) {
      if (ing && !tags.includes(ing)) {
        setTags(prevTags => [...prevTags, newIngredient])
        ++max
        setMax(max)
        // console.log('max:', max)
      }
    }
    setNewIngredient('')
    ingredientInput.current.focus()
  }

  // redirect the user when we get data response
  /*useEffect(() => {
    if (data) {
      navigate('/')
    }
  }, [data, navigate])
*/
  return (
    <div className="create">
      <h2 className="page-title">Create a Joke</h2>
      <form onSubmit={handleSubmit}>

        <label>
          <b>Joke title:</b>
          <input
            type="text"
            onChange={(e) => setTitle(e.target.value)}
            value={title}
            required
          />
        </label>

        <label>
          <b>Joke:</b>
          <textarea
            onChange={(e) => setBody(e.target.value)}
            value={body}
            required
          />
        </label>

        {/* <label>
          <b>Search Tags:</b>
          <div className="ingredients">
            <input
              type="text"
              onChange={(e) => setNewIngredient(e.target.value)}
              value={newIngredient}
              ref={ingredientInput}
            />
            <button onClick={handleAdd} className="btn">add</button>
          </div>
        </label>
        <b>Current Tags: {tags.map(i => <em key={i}>{i}, </em>)}</b>
        <br></br>  <b>Maximum of 3 Tags.</b> */}

        <button>Submit</button>
      </form>
    </div>
  )
}
